import React, { useState } from 'react';
import { Heading, Content } from 'components/api/text'
import CodeBox from 'components/code-box'
import { Link, useRouteMatch, useHistory } from 'react-router-dom'
import Button from 'components/button'
import Text from 'components/text'
import useGetAccessToken from '../../hooks/useGetAccessToken';
import useGetSelectedCampaign from 'app/campaigns/hooks/useGetSelectedCampaign'
import InsertUrls from '../../../docs/components/wordpress-docs/components/insert-urls';

const MarketerSetup = ({ mobileView, onDocs }) => {
    const match = useRouteMatch()
    const history = useHistory()
    const { data } = useGetAccessToken()

    const selectedCampaign = useGetSelectedCampaign()

    const getAccessTokenCode = () => {
        return `<script src="https://cdn.refmonkey.com/refmonkey.js"></script>
        <script type="text/javascript">
        window.refMonkeyClient = RefMonkey.client(${data ? '"' + data.generateAccessToken + '"' : 'YOUR_ACCESS_TOKEN'}); 
        `
    }
    return (
        <div className='w-full pb-16'>
            <Button
                tailwind={`w-full  ${!mobileView && 'md:w-auto'}`}
                variant='outline'
                size='extra-small'
                onClick={() => history.goBack()}
            >View all</Button>

            <Heading>RefMonkey Easy Setup</Heading>

            <Text>
                It’s super quick to get RefMonkey running on your website. Follow the walkthrough below to import the RefMonkey JavaScript library and integrate it on your website.
            </Text>

            <div className='mt-16'>
                <Content>
                    There are a few different ways to capture the email address of your visitors:
            </Content>
            </div>

            <Text
                font
                tailwind='mt-16 mb-8 font-md'
                type='heading-small'>AutoWatch</Text>
            <Content>
                The easiest way to track leads is with AutoWatch which will automatically watch all inputs on your site for a lead email. To enable this,
                 simply add the following javascript snippet in the head of your webpage - between the <b>{'<head>'}</b> and <b>{'</head>'}</b> HTML tags.:
        </Content>

            <CodeBox>{getAccessTokenCode() + `
        window.refMonkeyClient.autoWatch(${(selectedCampaign && selectedCampaign.cid) ? ('"' + selectedCampaign.cid + '"') : ''})

</script>`}
            </CodeBox>


            <Text
                font
                tailwind='mt-16 mb-8 font-md'
                type='heading-small'>Watch</Text>
            <Content>
                You can also use selectors to tell RefMonkey to watch particular inputs for a lead email. To enable this,
                 simply add the following javascript snippet instead in the head of your webpage - between the <b>{'<head>'}</b> and <b>{'</head>'}</b> HTML tags.:
        </Content>


            <CodeBox>{getAccessTokenCode() + `

        window.refMonkeyClient.watch("#email"${(selectedCampaign && selectedCampaign.cid) ? (',"' + selectedCampaign.cid + '"') : ''});     // will watch fields with the ID 'email'

</script>`}
            </CodeBox>


            <div className='mt-16'>
                <Content >
                    If you want more control over when the lead email is captured, use <Link
                        onClick={onDocs}
                        className='text-blue-500 hover:text-blue-400'
                        to={`/setup/js`}> Conversion Tracking</Link> instead.
        </Content>
            </div>


            <Text
                font
                tailwind='mt-16 mb-8 font-md'
                type='heading-small'>Restrict Url Paths (Optional)</Text>

            <Content>
                You can restrict conversions to only happen on specific url paths on your website.
        </Content>

            <InsertUrls />

            <div className='mt-16'>
                <Content ><b>Important:</b> This concludes our setup instructions for our most basic form of integration.</Content>
            </div>

            <Content>For all additional tracking posibilities, like referral links and more…
                 please check the<Link
                    onClick={onDocs}
                    className='text-blue-500 hover:text-blue-400'
                    to={`/setup/js`}> Javascript installation guide.</Link></Content>



        </div>
    );
};

MarketerSetup.propTypes = {

};

export default MarketerSetup;